const quickLinks = [
  { label: "홈", hash: "home" },
  { label: "변호사 소개", hash: "about" },
  { label: "언론보도", hash: "media" },
  { label: "수행사건", hash: "cases" },
  { label: "승소사례", hash: "cases-board" },
  { label: "상담안내", hash: "contact" },
];

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-white">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8">
          <div className="lg:col-span-1">
            <img
              src="/images/logo1.webp"
              alt="법무법인 효민"
              className="h-10 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-sm text-white/70 leading-relaxed">
              부동산·형사전문변호사 이승환<br />
              어려움에 처한 의뢰인에게 희망의 사다리가 되겠습니다.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-accent-400">바로가기</h4>
            <ul className="space-y-2">
              {quickLinks.map((item) => (
                <li key={item.hash}>
                  <a
                    href={`#${item.hash}`}
                    className="text-sm text-white/70 hover:text-accent-400 transition-colors"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-accent-400">연락처</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm text-white/70">
                <span className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-phone-line text-accent-400" />
                </span>
                <a href="tel:02-3471-3690" className="hover:text-white transition-colors">
                  02-3471-3690
                </a>
              </li>
              <li className="flex items-start gap-2 text-sm text-white/70">
                <span className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-accent-400" />
                </span>
                <span>서울 서초구 반포대로28길 79<br />지정빌딩 3층, 법무법인 효민</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-accent-400">외부 링크</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="https://m.booking.naver.com/booking/6/bizes/216261/items/2986580?area=pll&lang=ko&startDate=2026-08-13&theme=place"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-sm text-white/70 hover:text-accent-400 transition-colors"
                >
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-calendar-check-line" />
                  </span>
                  네이버 예약
                </a>
              </li>
              <li>
                <a
                  href="https://blog.naver.com/hmlaw3690"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-sm text-white/70 hover:text-accent-400 transition-colors"
                >
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-article-line" />
                  </span>
                  네이버 블로그
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/50">
            &copy; 2026 법무법인 효민. All rights reserved.
          </p>
          <p className="text-xs text-white/50">
            광고책임변호사 : 이승환
          </p>
        </div>
      </div>
    </footer>
  );
}